import { FC } from "react";
import useEmploymentContractCreate from "./hook";
import { Styles } from "./styled";
import CreatePage from "@lhd/components/CloneApp/pages/CreatePage";
import { APP_TYPES } from "@lhd/components/CloneApp/constants";
import { ROUTES } from "@lhd/constants";

const EmploymentContractsLayout = (
  props: ReturnType<typeof useEmploymentContractCreate>,
) => {
  return (
    <Styles>
      <CreatePage
        appType={APP_TYPES.EMPLOYMENT_CONTRACTS}
        url={`/${ROUTES.EMPLOYMENT_CONTRACTS}`}
      />
    </Styles>
  );
};

const EmploymentContractCreate: FC = () => (
  <EmploymentContractsLayout {...useEmploymentContractCreate()} />
);

export default EmploymentContractCreate;
